import { render, staticRenderFns } from "./ordass.vue?vue&type=template&id=b2354906&scoped=true&"
import script from "./ordass.vue?vue&type=script&lang=js&"
export * from "./ordass.vue?vue&type=script&lang=js&"
import style0 from "./ordass.vue?vue&type=style&index=0&id=b2354906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2354906",
  null
  
)

export default component.exports